import React from 'react';
import { motion } from 'framer-motion';
import { DiamondMark } from '../components/DiamondMark';
import { Logo } from '../components/Logo';
export function NotAFit() {
  return <div className="min-h-screen bg-white text-bg-primary font-sans selection:bg-accent selection:text-bg-primary" data-id="element-31">
      {/* Centered logo */}
      <div className="w-full flex justify-center pt-12 md:pt-16" data-id="element-32">
        <Logo height={36} data-id="element-33" />
      </div>

      {/* Section 1 — The Acknowledgment */}
      <section className="w-full px-6 md:px-12 lg:px-24 pt-12 md:pt-16 pb-16 md:pb-24" data-id="element-34">
        <div className="max-w-3xl mx-auto text-center" data-id="element-35">
          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeOut',
          delay: 0.1
        }} className="font-display font-extrabold text-[36px] md:text-[56px] leading-[1.1] tracking-tightest text-bg-primary mb-8" data-id="element-36">
            We Appreciate You Stopping By.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-lg md:text-[22px] leading-relaxed text-bg-primary/70 max-w-2xl mx-auto" data-id="element-37">
            RIA Catalyst is built specifically for wealth advisors managing
            $250M+ in AUM at wirehouses, captive bank teams, and PE-backed RIAs.
            Based on your responses, we're not the right fit for your current
            situation — and we'd rather tell you that directly than waste your
            time on a call that doesn't serve you.
          </motion.p>
        </div>
      </section>

      {/* Section 2 — The Honest Reasoning */}
      <section className="w-full px-6 md:px-12 lg:px-24 py-16 md:py-24" data-id="element-38">
        <div className="max-w-[720px] mx-auto border-t border-b border-bg-primary/15 py-16 md:py-20" data-id="element-39">
          <motion.span initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="block text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-bg-primary/60 mb-6" data-id="element-40">
            Why The Threshold
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3,
          ease: 'easeOut',
          delay: 0.1
        }} className="font-display font-bold text-[28px] md:text-[36px] leading-tight tracking-tightest text-bg-primary mb-10" data-id="element-41">
            Why We Hold The Line At $250M.
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3,
          ease: 'easeOut',
          delay: 0.2
        }} className="text-lg md:text-xl text-bg-primary/75 space-y-6" style={{
          lineHeight: 1.6
        }} data-id="element-42">
            <p data-id="element-43">
              The transition we negotiate isn't a generic recruiter placement.
              It's a structured deal — transition capital, equity participation,
              multi-year compensation guarantees, client protection
              architecture, and legal sequencing through Protocol and
              non-Protocol exits.
            </p>
            <p data-id="element-44">
              The independent RIAs we work with deploy this capital for books
              that justify the complexity. For a $250M+ book, the receiving firm
              pays a fee that covers our work and still creates a strong return
              for them. Below that threshold, the economics don't work — for the
              receiving firm, for us, or for the advisor.
            </p>
            <p data-id="element-45">
              We could pretend otherwise and take the call anyway. We don't,
              because the advisor walks away with nothing actionable. That's
              worse than not having the call at all.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Section 3 — If We Got It Wrong */}
      <section className="w-full px-6 md:px-12 lg:px-24 py-16 md:py-24" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="max-w-[640px] mx-auto text-center" data-id="element-47">
          <div className="inline-flex items-center gap-2 mb-5" data-id="element-48">
            <span className="text-accent text-[10px]" data-id="element-49">●</span>
            <span className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-bg-primary" data-id="element-50">
              If We Got This Wrong
            </span>
          </div>
          <h3 className="font-display font-bold text-[24px] md:text-[32px] tracking-tightest text-bg-primary mb-6" data-id="element-51">
            Managing $250M+? Reach Out Directly.
          </h3>
          <p className="text-[17px] md:text-lg leading-relaxed text-bg-primary/75 mb-8" data-id="element-52">
            If our screening misread your situation and you're managing $250M+
            in AUM at a wirehouse, captive bank team, or PE-backed RIA, email
            Julien directly and we'll take another look.
          </p>
          <a href="mailto:julien@riagrowthcatalyst.com" className="inline-flex items-center justify-center px-7 py-3.5 bg-bg-primary text-white font-semibold rounded-full text-base md:text-lg transition-all duration-200 hover:scale-[1.02] hover:bg-bg-secondary shadow-[0_8px_24px_rgba(14,26,53,0.2)]" data-id="element-53">
            julien@riagrowthcatalyst.com
          </a>
        </motion.div>
      </section>

      {/* Section 4 — The Final Line */}
      <section className="w-full px-6 md:px-12 lg:px-24 pt-16 md:pt-24 pb-12" data-id="element-54">
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center gap-8 text-bg-primary" data-id="element-55">
          <p className="text-[17px] md:text-lg text-bg-primary/70" data-id="element-56">
            Thank you for considering RIA Catalyst. We appreciate the
            conversation.
          </p>
          <DiamondMark data-id="element-57" />
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full px-6 md:px-12 lg:px-24 pb-10" data-id="element-58">
        <p className="text-center text-[12px] text-bg-primary/50" data-id="element-59">
          RIA Catalyst © 2026
        </p>
      </footer>
    </div>;
}